import 'url-search-params-polyfill';
/**
 * 获取URL param 值
 * @param {String} key URL参数key
 */
export function getParam(key) {
    if (!key)
        return '';
    var search = new URLSearchParams(window.location.search);
    return search.get(key);
}
/**
 *
 * @param {String}} filepath
 * @param {Function} onloadCallback
 */
export function pageLoadScript(filepath, onloadCallback) {
    var scriptDom = document.createElement('script');
    scriptDom.onload = onloadCallback;
    scriptDom.onreadystatechange = onloadCallback;
    scriptDom.type = 'text/javascript';
    // attach full refer for backend calculating signature
    scriptDom.referrerPolicy = 'unsafe-url';
    scriptDom.src = filepath;
    document.body.appendChild(scriptDom);
}
export function getQQVersion() {
    var ua = navigator.userAgent;
    var qqIndex = ua.indexOf('QQ/');
    var qqEnd = ua.indexOf(' ', qqIndex);
    var qqStr = ua.substring(qqIndex + 3, qqEnd);
    var qqArr = qqStr.split('.');
    var qqInt = Number(qqArr[0]) * 10 + Number(qqArr[1]);
    return qqInt;
}
